import { Button, Row, Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import SectionSeparator from "../SectionSeparator";
import { FiPlus, FiMinus } from "react-icons/fi";

const MediaConsentStep = ({ ctx }) => {
  const {
    chronicIllnesses,
    illnesses,
    conditions,
    chronicIllness,
    setChronicIllness,
    chronicIllnessDesc,
    setChronicIllnessDesc,
    illness,
    setIllness,
    illnessDesc,
    setIllnessDesc,
    condition,
    setCondition,
    conditionDesc,
    setConditionDesc,
    health_declarations,
    addHealthDeclaration,
    removeHealthDeclaration,
  } = ctx;

  return (
    <>
      {/* Chronic Illnesses */}
      <SectionSeparator title="title.health_declaration_form" />
      <Row>
        <Col md={12}>
          {" "}
          <Form.Label>
            <FormattedMessage id="chronic_illness" />
          </Form.Label>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4">
            <Form.Select
              onChange={(e) => setChronicIllness(e.target.value)}
              value={chronicIllness}
            >
              <option value="">
                <FormattedMessage id="select" />
              </option>
              {chronicIllnesses.map((illness, index) => (
                <option key={index} value={illness}>
                  {illness}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={5}>
          <FormattedMessage id="info_treatments_medications">
            {(placeholder) => (
              <Form.Control
                value={chronicIllnessDesc}
                placeholder={placeholder}
                type="text"
                onChange={(e) => setChronicIllnessDesc(e.target.value)}
              />
            )}
          </FormattedMessage>
        </Col>
        {/* <Col md={3}>
                        <Form.Group className="mb-4">
                          <FormattedMessage id="date">
                            {(placeholder) => (
                              <DatePicker
                                placeholderText={placeholder}
                                className={"form-control"}
                                selected={chronicIllnessDate}
                                onChange={(date) => setChronicIllnessDate(date)}
                              />
                            )}
                          </FormattedMessage>
                        </Form.Group>
                      </Col> */}
        <Col md={1} className="ps-4">
          <Button
            variant="success"
            size="sm"
            onClick={() => addHealthDeclaration("Chronic Illness")}
          >
            <FiPlus />
          </Button>
        </Col>
      </Row>
      {health_declarations
        .filter(
          (healthDeclaration) =>
            healthDeclaration.child_health_type === "Chronic Illness",
        )
        .map((healthDeclaration, index) => (
          <Row key={index} className="mb-3">
            <Col md={3} className="ps-4">
              {healthDeclaration.child_health_name}
            </Col>
            <Col md={5} className="ps-4">
              {healthDeclaration.child_health_desc}
            </Col>
            {/* <Col md={3} className="ps-4">
                            {moment(healthDeclaration.child_health_date).format(
                              "DD/MM/YYYY"
                            )}
                          </Col> */}
            <Col md={1} className="ps-4">
              <Button
                variant="danger"
                size="sm"
                onClick={() => removeHealthDeclaration(healthDeclaration.uuid)}
              >
                <FiMinus />
              </Button>
            </Col>
          </Row>
        ))}

      <hr />

      {/* Illnesses */}
      <Row>
        <Col md={12}>
          {" "}
          <Form.Label>
            <FormattedMessage id="child_illness" />
          </Form.Label>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4">
            <Form.Select
              onChange={(e) => setIllness(e.target.value)}
              value={illness}
            >
              <option value="">
                <FormattedMessage id="select" />
              </option>
              {illnesses.map((illness, index) => (
                <option key={index} value={illness}>
                  {illness}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={5}>
          <FormattedMessage id="info_treatments_medications">
            {(placeholder) => (
              <Form.Control
                value={illnessDesc}
                placeholder={placeholder}
                type="text"
                onChange={(e) => setIllnessDesc(e.target.value)}
              />
            )}
          </FormattedMessage>
        </Col>
        {/* <Col md={3}>
                        <Form.Group className="mb-4">
                          <FormattedMessage id="date">
                            {(placeholder) => (
                              <DatePicker
                                placeholderText={placeholder}
                                className={"form-control"}
                                selected={illnessDate}
                                onChange={(date) => setIllnessDate(date)}
                              />
                            )}
                          </FormattedMessage>
                        </Form.Group>
                      </Col> */}
        <Col md={1} className="ps-4">
          <Button
            variant="success"
            size="sm"
            onClick={() => addHealthDeclaration("Illness")}
          >
            <FiPlus />
          </Button>
        </Col>
      </Row>
      {health_declarations
        .filter(
          (healthDeclaration) =>
            healthDeclaration.child_health_type === "Illness",
        )
        .map((healthDeclaration, index) => (
          <Row key={index} className="mb-3">
            <Col md={3} className="ps-4">
              {healthDeclaration.child_health_name}
            </Col>
            <Col md={5} className="ps-4">
              {healthDeclaration.child_health_desc}
            </Col>
            {/* <Col md={3} className="ps-4">
                            {moment(healthDeclaration.child_health_date).format(
                              "DD/MM/YYYY"
                            )}
                          </Col> */}
            <Col md={1} className="ps-4">
              <Button
                variant="danger"
                size="sm"
                onClick={() => removeHealthDeclaration(healthDeclaration.uuid)}
              >
                <FiMinus />
              </Button>
            </Col>
          </Row>
        ))}

      <hr />

      {/* Condition */}
      <Row>
        <Col md={12}>
          {" "}
          <Form.Label>
            <FormattedMessage id="child_conditions" />
          </Form.Label>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-4">
            <Form.Select
              onChange={(e) => setCondition(e.target.value)}
              value={condition}
            >
              <option value="">
                <FormattedMessage id="select" />
              </option>
              {conditions.map((condition, index) => (
                <option key={index} value={condition}>
                  {condition}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={5}>
          <FormattedMessage id="info_treatments_medications">
            {(placeholder) => (
              <Form.Control
                value={conditionDesc}
                placeholder={placeholder}
                type="text"
                onChange={(e) => setConditionDesc(e.target.value)}
              />
            )}
          </FormattedMessage>
        </Col>
        {/* <Col md={3}>
                        <Form.Group className="mb-4">
                          <FormattedMessage id="date">
                            {(placeholder) => (
                              <DatePicker
                                placeholderText={placeholder}
                                className={"form-control"}
                                selected={conditionDate}
                                onChange={(date) => setConditionDate(date)}
                              />
                            )}
                          </FormattedMessage>
                        </Form.Group>
                      </Col> */}
        <Col md={1} className="ps-4">
          <Button
            variant="success"
            size="sm"
            onClick={() => addHealthDeclaration("Condition")}
          >
            <FiPlus />
          </Button>
        </Col>
      </Row>
      {health_declarations
        .filter(
          (healthDeclaration) =>
            healthDeclaration.child_health_type === "Condition",
        )
        .map((healthDeclaration, index) => (
          <Row key={index} className="mb-3">
            <Col md={3} className="ps-4">
              {healthDeclaration.child_health_name}
            </Col>
            <Col md={5} className="ps-4">
              {healthDeclaration.child_health_desc}
            </Col>
            {/* <Col md={3} className="ps-4">
                            {moment(healthDeclaration.child_health_date).format(
                              "DD/MM/YYYY"
                            )}
                          </Col> */}
            <Col md={1} className="ps-4">
              <Button
                variant="danger"
                size="sm"
                onClick={() => removeHealthDeclaration(healthDeclaration.uuid)}
              >
                <FiMinus />
              </Button>
            </Col>
          </Row>
        ))}
      <Row>
        <Col md={12}>
          <p className="fw-bold text-break">
            If Medication is required, a Medication Form should be completed and
            submitted along with the medication to the MLS nurse on the first
            day of school
          </p>
        </Col>
      </Row>
    </>
  );
};

export default MediaConsentStep;
